import { prependAppName } from "shared/imports/sharedHelperFunctions"
import { makePieActionObjs } from "shared/imports/pieActionGenerators"
const appName = "@@account_management/"

const AccountActions = {
    ADD_PRODUCT: "app/organization/ADD_PRODUCT",

    CHANGE_DESIGN: "app/OrgDesign/CHANGE_DESIGN",

    CHANGE_INFO: "app/AccountInfo/CHANGE_INFO",

    CREATE_TEAM_FAIL: "app/organization/CREATE_TEAM_FAIL",
    CREATE_TEAM_START: "app/organization/CREATE_TEAM_START",
    CREATE_TEAM_SUCCESS: "app/organization/CREATE_TEAM_SUCCESS",

    CREATE_USER_FAIL: "app/registration/CREATE_USER_FAIL",
    CREATE_USER_START: "app/registration/CREATE_USER_START",
    CREATE_USER_SUCCESS: "app/registration/CREATE_USER_SUCCESS",

    DEACTIVATE_ORG_FAIL: "app/organization/DEACTIVATE_ORG_FAIL",
    DEACTIVATE_ORG_START: "app/organization/DEACTIVATE_ORG_START",
    DEACTIVATE_ORG_SUCCESS: "app/organization/DEACTIVATE_ORG_SUCCESS",

    DEACTIVATE_USER: "app/OrgManagement/DEACTIVATE_USER",

    EDIT_FILTERS: "app/AccountInfo/EDIT_FILTERS",

    EDIT_ORG: "app/organization/EDIT_ORG",

    EDIT_ORG_SET_IN: "app/organization/EDIT_ORG_SET_IN",

    EDIT_ORG_UI_STATE: "app/organization/EDIT_ORG_UI_STATE",

    EDIT_PRODUCTS: "app/organization/EDIT_PRODUCTS",

    EDIT_TEAM: "app/organization/EDIT_TEAM",

    EDIT_TEAM_UI_STATE: "app/organization/EDIT_TEAM_UI_STATE",
    EDIT_USER_UI_STATE: "app/organization/EDIT_USER_UI_STATE",

    GET_ORG_FAIL: "app/organization/GET_ORG_FAIL",
    GET_ORG_START: "app/organization/GET_ORG_START",
    GET_ORG_SUCCESS: "app/organization/GET_ORG_SUCCESS",

    GET_TEAM_FAIL: "app/organization/GET_TEAM_FAIL",
    GET_TEAM_START: "app/organization/GET_TEAM_START",
    GET_TEAM_SUCCESS: "app/organization/GET_TEAM_SUCCESS",

    GET_TEAMS_FOR_USER_FORM_FAIL: "GET_TEAMS_FOR_USER_FORM_FAIL",
    GET_TEAMS_FOR_USER_FORM_START: "GET_TEAMS_FOR_USER_FORM_START",
    GET_TEAMS_FOR_USER_FORM_SUCCESS: "GET_TEAMS_FOR_USER_FORM_SUCCESS",

    GET_USER_COUNT: "app/OrgManagement/GET_USER_COUNT",

    GET_USER_FAIL: "app/organization/GET_USER_FAIL",
    GET_USER_START: "app/organization/GET_USER_START",
    GET_USER_SUCCESS: "app/organization/GET_USER_SUCCESS",

    GET_USERS_FAIL: "app/organization/GET_USERS_FAIL",
    GET_USERS_START: "app/organization/GET_USERS_START",
    GET_USERS_SUCCESS: "app/organization/GET_USERS_SUCCESS",

    // set up the use form in the redux store
    INIT_USER_FORM: "INIT_USER_FORM",

    PATCH_ORG_FAIL: "app/organization/PATCH_ORG_FAIL",
    PATCH_ORG_START: "app/organization/PATCH_ORG_START",
    PATCH_ORG_SUCCESS: "app/organization/PATCH_ORG_SUCCESS",

    PATCH_TEAM_FAIL: "app/organization/PATCH_TEAM_FAIL",
    PATCH_TEAM_START: "app/organization/PATCH_TEAM_START",
    PATCH_TEAM_SUCCESS: "app/organization/PATCH_TEAM_SUCCESS",

    PATCH_USER_FAIL: "app/organization/PATCH_USER_FAIL",
    PATCH_USER_START: "app/organization/PATCH_USER_START",
    PATCH_USER_SUCCESS: "app/organization/PATCH_USER_SUCCESS",

    REACTIVATE_USER: "app/OrgManagement/REACTIVATE_USER",

    REORDER_SIDEBAR: "app/Sidebar/REORDER_SIDEBAR",

    RESEND_ACTIVATION_EMAIL_FAIL: "app/organization/GET_TEAM_RESEND_ACTIVATION_EMAIL_FAIL",
    RESEND_ACTIVATION_EMAIL_START: "app/organization/GET_TEAM_RESEND_ACTIVATION_EMAIL_START",
    RESEND_ACTIVATION_EMAIL_SUCCESS: "app/organization/GET_TEAM_RESEND_ACTIVATION_EMAIL_SUCCESS",

    RESET_FORM: "app/OrgDesign/RESET_FORM",

    DELETE_DESIGN: "app/OrgDesign/DELETE_DESIGN",

    SECURE_UPLOAD: "app/AccountInfo/SECURE_UPLOAD",

    PATCH_ORG_DESIGN_START: "PATCH_ORG_DESIGN_START",
    PATCH_ORG_DESIGN_SUCCESS: "PATCH_ORG_DESIGN_SUCCESS",
    PATCH_ORG_DESIGN_FAIL: "PATCH_ORG_DESIGN_FAIL",

    SET_PRIMARY_PRODUCT_USED: "app/AccountInfo/SET_PRIMARY_PRODUCT_USED",

    SET_DEFAULT_ALL_APPLICABLE_USER_TYPES: "app/AccountInfo/SET_DEFAULT_ALL_APPLICABLE_USER_TYPES",

    SET_VALID: "app/OrgDesign/SET_VALID",

    TOGGLE_CREATE_MODE: "app/OrgDesign/TOGGLE_CREATE_MODE",

    TOGGLE_PICKER: "app/OrgDesign/TOGGLE_PICKER",

    UPDATE_ORG: "app/organization/UPDATE_ORG",

    USER_ACTIVATION_CHANGE: "app/AccountInfo/USER_ACTIVATION_CHANGE",

    USER_FORM_START_SEARCHIFY: "app/AccountInfo/USER_FORM_START_SEARCHIFY",

    USER_FORM_AMENDMENT_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_AMENDMENT_SUBMIT_SEARCHIFY",

    USER_FORM_BILL_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_BILL_SUBMIT_SEARCHIFY",

    USER_FORM_DOCUMENT_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_DOCUMENT_SUBMIT_SEARCHIFY",

    USER_FORM_EVENT_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_EVENT_SUBMIT_SEARCHIFY",

    USER_FORM_NOTE_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_NOTE_SUBMIT_SEARCHIFY",

    USER_FORM_PERSON_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_PERSON_SUBMIT_SEARCHIFY",

    USER_FORM_PUBLIC_ORGANIZATION_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_PUBLIC_ORGANIZATION_SUBMIT_SEARCHIFY",

    USER_FORM_STAFFER_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_STAFFER_SUBMIT_SEARCHIFY",

    USER_FORM_SUPPORTER_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_SUPPORTER_SUBMIT_SEARCHIFY",

    USER_FORM_VOTE_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_VOTE_SUBMIT_SEARCHIFY",

    USER_FORM_ALERT_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_ALERT_SUBMIT_SEARCHIFY",

    USER_FORM_ARTICLE_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_ARTICLE_SUBMIT_SEARCHIFY",

    USER_FORM_PRESS_CONTACT_SUBMIT_SEARCHIFY: "app/AccountInfo/USER_FORM_PRESS_CONTACT_SUBMIT_SEARCHIFY",
}

export const getOrgTypes = {
    start: AccountActions.GET_ORG_START,
    success: AccountActions.GET_ORG_SUCCESS,
    fail: AccountActions.GET_ORG_FAIL,
}

const getDefaultDesignObjs = makePieActionObjs("get", "default_design")
export const getDefaultDesign = prependAppName(appName, getDefaultDesignObjs.pieDict)

export const patchOrgTypes = {
    start: AccountActions.PATCH_ORG_START,
    success: AccountActions.PATCH_ORG_SUCCESS,
    fail: AccountActions.PATCH_ORG_FAIL,
}

const deactivateOrgObjs = makePieActionObjs("deactivate", "Organization")
export const deactivateOrgActionTypes = prependAppName(appName, deactivateOrgObjs.pieDict)

export const createTeamTypes = {
    start: AccountActions.CREATE_TEAM_START,
    success: AccountActions.CREATE_TEAM_SUCCESS,
    fail: AccountActions.CREATE_TEAM_FAIL,
}

export const getTeamTypes = {
    start: AccountActions.GET_TEAM_START,
    success: AccountActions.GET_TEAM_SUCCESS,
    fail: AccountActions.GET_TEAM_FAIL,
}

export const patchTeamTypes = {
    start: AccountActions.PATCH_TEAM_START,
    success: AccountActions.PATCH_TEAM_SUCCESS,
    fail: AccountActions.PATCH_TEAM_FAIL,
}

export const patchUserTypes = {
    start: AccountActions.PATCH_USER_START,
    success: AccountActions.PATCH_USER_SUCCESS,
    fail: AccountActions.PATCH_USER_FAIL,
}

export const resendActivationEmailTypes = {
    start: AccountActions.RESEND_ACTIVATION_EMAIL_START,
    success: AccountActions.RESEND_ACTIVATION_EMAIL_SUCCESS,
    fail: AccountActions.RESEND_ACTIVATION_EMAIL_FAIL,
}

export const patchOrgDesignTypes = {
    start: AccountActions.PATCH_ORG_DESIGN_START,
    success: AccountActions.PATCH_ORG_DESIGN_SUCCESS,
    fail: AccountActions.PATCH_ORG_DESIGN_FAIL,
}

export const getTeamsForUserFormTypes = {
    start: AccountActions.GET_TEAMS_FOR_USER_FORM_START,
    success: AccountActions.GET_TEAMS_FOR_USER_FORM_SUCCESS,
    fail: AccountActions.GET_TEAMS_FOR_USER_FORM_FAIL,
}

export const changePasswordActionTypes = prependAppName(appName, makePieActionObjs("change_password", "user").pieDict)
export const updateInformationSettingsActionDict = prependAppName(
    appName,
    makePieActionObjs("CHANGE_MY_INFORMATION", "USER").pieDict,
)
export const updateSearchSettingsActionTypes = prependAppName(
    appName,
    makePieActionObjs("change_search_settings", "user").pieDict,
)
export const updateSidebarSettingsActionDict = prependAppName(
    appName,
    makePieActionObjs("CHANGE_SIDEBAR_SETTINGS", "USER").pieDict,
)
export const updateOrgAsOrgAdminActionDict = prependAppName(
    appName,
    makePieActionObjs("UPDATE", "ORG_ADMIN_SETTINGS").pieDict,
)
export const verifyDomainActionDict = prependAppName(appName, makePieActionObjs("verify", "domain").pieDict)

export default AccountActions
